module.exports = __webpack_public_path__ + "media/images/flags/64/Thailand-08d3b29a428136fa0171bbacc562c91d.png";